import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { FulfillService } from '../../fulfill.service';
import { PanelState } from '../../utils/models';
import { takeUntil } from 'rxjs/operators';
import { OrderActionsService } from '@app/dashboard/print/services/order-actions.service';
import { ActivatedRoute } from '@angular/router';
import { LayoutService } from '@app/storybook/services/layout/layout.service';
@Component({
  selector: 'fulfill-side-panel',
  templateUrl: './fulfill-side-panel.component.html',
  styleUrls: ['./fulfill-side-panel.component.scss'],
  standalone: false,
})
export class FulfillSidePanelComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject();
  isPanelOpen: boolean;
  panelState: PanelState;
  activeBatch = null;
  activeOrder = null;
  isLoadedActiveBatch = false;
  isLoadedActiveOrder = false;
  headerHeight$ = this.layoutService.headerHeight$;
  constructor(
    private fulfillService: FulfillService,
    private orderActionsService: OrderActionsService,
    private route: ActivatedRoute,
    private layoutService: LayoutService,
  ) {}

  ngOnInit(): void {
    this.fulfillService.onSetPanelState.pipe(takeUntil(this.destroy$)).subscribe((newState) => {
      this.panelState = newState;
    });

    this.fulfillService.onTogglePanel.pipe(takeUntil(this.destroy$)).subscribe((newState) => {
      this.isPanelOpen = newState;
    });

    this.fulfillService.activeBatch$.pipe(takeUntil(this.destroy$)).subscribe((activeBatch) => {
      this.activeBatch = activeBatch;
      this.isLoadedActiveBatch = !!this.activeBatch;
      if (this.activeBatch) this.fulfillService.togglePanel(true);
    });

    this.fulfillService.onChosenBatch.pipe(takeUntil(this.destroy$)).subscribe((isOpenSidePanel: boolean) => {
      this.fulfillService.togglePanel(isOpenSidePanel);
    });

    this.fulfillService.activeOrder$.pipe(takeUntil(this.destroy$)).subscribe((activeOrder) => {
      this.activeOrder = activeOrder;
      this.isLoadedActiveOrder = !!this.activeOrder;
    });

    this.fulfillService.onScanOrder.pipe(takeUntil(this.destroy$)).subscribe((activeOrder) => {
      if (activeOrder) {
        this.loadedOrderAction(activeOrder, this.fulfillService.shopMetadata);
      }
    });
  }

  ngOnDestroy(): void {
    this.activeBatch = null;
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  loadedOrderAction(order, shopMetadata) {
    const orderOpenedFromScan = this.route.snapshot.queryParams['from'] === 'scan';
    const { greetingCard } = shopMetadata;
    if (greetingCard && greetingCard?.openInFulfillFlow && greetingCard?.active && orderOpenedFromScan) {
      const targetProperty = shopMetadata?.greetingCard?.from;
      if (order[targetProperty]) this.orderActionsService.openGreetingCardForOrder([order.id]);
    }
  }

  setPanelState() {
    if (!this.activeBatch && !this.activeOrder) {
      this.panelState = PanelState.SCAN;
    } else if (this.activeOrder) {
      this.panelState = PanelState.ORDER;
    } else if (this.activeBatch && !this.activeOrder) {
      this.panelState = PanelState.BATCH;
    }
  }
  togglePanel() {
    this.fulfillService.togglePanel();
    this.fulfillService.setPanelState(PanelState.SCAN);
  }
}
